import { apiEndpoints } from "@/services/api/api";

export async function orderHistoryLoader() {
  const response = await apiEndpoints.getUserOrders();
  return response.data;
}

